import React from "react";
import logo from "../../assets/images/inrssd-logo.PNG";

const INRSSD = () => {
  return (
    <>
      <style>{`
        .inrssd-page {
          max-width: 1100px;
          margin: auto;
          padding: 3rem 1.5rem;
          font-family: Arial, Helvetica, sans-serif;
          font-size: 1.05rem;
          line-height: 1.8;
          color: #1f2937;
        }

        .inrssd-header {
          text-align: center;
          margin-bottom: 3rem;
        }

        .inrssd-header img {
          max-width: 120px;
          margin-bottom: 1rem;
        }

        .inrssd-header h1 {
          font-size: 2.4rem;
          margin-bottom: 0.8rem;
          color: #0f766e;
        }

        .inrssd-header p {
          font-size: 1.15rem;
          max-width: 850px;
          margin: 0 auto;
        }

        section {
          margin-bottom: 2.5rem;
        }

        h2 {
          font-size: 1.6rem;
          color: #0f766e;
          margin-bottom: 0.8rem;
        }

        ul {
          padding-left: 1.2rem;
        }

        li {
          margin-bottom: 0.6rem;
        }

        .two-column {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2.5rem;
        }
      `}</style>

      <div className="inrssd-page">
        <header className="inrssd-header">
          <h1> 00 </h1>
          <img src={logo} alt="INRSSD Logo" />
          <h1>
            Institute of Natural Resource Sciences and Sustainable Development
            (INRSSD)
          </h1>
          <p>
            Advancing knowledge, resilience, and sustainable solutions for
            communities and the planet.
          </p>
        </header>

        <section>
          <h2>About INRSSD</h2>
          <p>
            The Institute of Natural Resource Sciences and Sustainable Development
            (INRSSD) is an established educational and research institution dedicated
            to advancing knowledge and skills in the sustainable management of
            natural resources.
          </p>
          <p>
            The institute was founded in response to increasing national and regional
            needs for trained professionals who can address environmental challenges,
            improve water and food security, strengthen climate resilience, reduce
            disaster risks, and promote adaptive governance and sustainable land and
            resource use.
          </p>
        </section>

        <section className="two-column">
          <div>
            <h2>INRSSD Vision</h2>
            <p>
              To be a leading centre of excellence in education and research in natural resource sciences, 
              fostering innovation, advancing knowledge, and nurturing skilled professionals who are committed to responsible resource management.
               We aim to empower communities through inclusive learning, impactful research, and practical solutions that address local and global challenges, 
               while shaping sustainable futures for our community and the planet.
            </p>
          </div>

          <div>
            <h2>INRSSD Mission</h2>
            <ul>
              <li>
                Provide high-quality education and training in natural resource
                management and environmental sciences.
              </li>
              <li>
                Conduct innovative and applied research supporting sustainable
                solutions.
              </li>
              <li>
                Engage communities, governments, and industry to promote equitable
                resource access.
              </li>
              <li>
                Develop ethical, skilled, and socially responsible professionals.
              </li>
            </ul>
          </div>
        </section>

       <section className="two-column">
        <div>
          <h2>Core Values</h2>
          <ul>
            <li><strong>Excellence</strong> – Highest standards in education and research</li>
            <li><strong>Integrity</strong> – Ethical and transparent conduct</li>
            <li><strong>Sustainability</strong> – Long-term environmental responsibility</li>
            <li><strong>Community Impact</strong> – Local engagement and capacity building</li>
            <li><strong>Collaboration</strong> – Partnerships for real-world impact</li>
          </ul>
        </div>

          <div>
          <h2>Focus Areas</h2>
          <ul>
            <li>Natural Resource Management</li>
            <li>Water Resources & Hydrology</li>
            <li>Wildlife, Fisheries & Aquatic Systems</li>
            <li>Environmental Policy, Law & Governance</li>
            <li>Geospatial Analysis, Monitoring & Modeling</li>
            <li>Environmental Economics & Resource Management</li>
            <li>Food Systems, Food Security & Sustainable Agriculture</li>
            <li>Climate Change, Resilience & Disaster Risk Management</li>
          </ul>
          </div>
        </section>
      </div>
    </>
  );
};

export default INRSSD;
